<template>
  <!-- Delete -->
  <v-dialog v-model="deleteDialog" width="400px" persistent>
    <template v-slot:activator="{ on }">
      <v-btn v-bind="size" v-on="on" class="ma-2" slot="activator" fab accent>
        <v-icon>delete</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card>
        <v-card-title color="red" class="headline">
          <v-icon class="mr-2" color="red">warning</v-icon> Delete Item?
        </v-card-title>
        <v-card-text
          >Are you sure you would like to delete this item? Please note that
          this is an irreversible action.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col></v-col>
          <v-row>
            <v-btn
              v-bind="size"
              color="green darken-1"
              text
              @click="dialog = false"
            >
              No, dont delete.
            </v-btn>
          </v-row>
          <v-row>
            <v-btn v-bind="size" color="red darken-1" text @click="removeItem">
              Yes, delete this.
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import firebase from "firebase/compat/app";
export default {
  props: ['item'],
  components: {},

  data() {
    return {
      dialog: false
    }
  },
  computed: {
    size() {
      const size = { xs: 'small', sm: 'small', lg: 'medium', xl: 'medium' }[
        this.$vuetify.breakpoint.name
      ]
      return size ? { [size]: true } : {}
    }
  },
  methods: {
    removeItem(item) {
      db.collection('items')
        .doc('item.id')
        .delete()
      console.log(item)
    }
  }
}
</script>
